import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "customerDialog",
    "customerForm",
    "customerMappingId",
    "paymentMethodDialog",
    "paymentMethodForm",
    "paymentMethodMappingId",
  ]

  chooseCustomer(event) {
    if (event.detail.success) this.#clearSearchInput(this.customerDialogTarget)
    this.#closeDialog(this.customerDialogTarget)
  }

  choosePaymentMethod(event) {
    if (event.detail.success) this.#clearSearchInput(this.paymentMethodDialogTarget)
    this.#closeDialog(this.paymentMethodDialogTarget)
  }

  openCustomerDialog(event) {
    this.customerFormTarget.action = event.currentTarget.dataset.selectUrl
    this.customerMappingIdTarget.value = event.currentTarget.dataset.mappingId
    this.#openDialog(this.customerDialogTarget)
    this.#applySearchPrefill(this.customerDialogTarget, event.currentTarget.dataset.searchPrefill)
  }

  openPaymentMethodDialog(event) {
    this.paymentMethodFormTarget.action = event.currentTarget.dataset.selectUrl
    this.paymentMethodMappingIdTarget.value = event.currentTarget.dataset.mappingId
    this.#openDialog(this.paymentMethodDialogTarget)
    this.#applySearchPrefill(this.paymentMethodDialogTarget, event.currentTarget.dataset.searchPrefill)
  }

  // After a successful selection the server clears the results, so clear the
  // query too — otherwise the next open would show stale text over empty results.
  #clearSearchInput(target) {
    target.querySelector("input[type='search']").value = ""
  }

  #applySearchPrefill(target, prefill = "") {
    const input = target.querySelector("input[type='search']")
    input.focus()

    // Only overwrite when there's a prefill — and re-run the search so the
    // results match it (the search form listens for `input` via the
    // submit-on-change controller). Without a prefill we leave the prior query
    // and its results untouched so the two never drift out of sync.
    if (prefill) {
      input.value = prefill
      input.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  #openDialog(target) {
    const dialogElement = target.querySelector('[data-controller*="dialog"]')
    const controller = this.application.getControllerForElementAndIdentifier(
      dialogElement,
      "dialog"
    )
    controller?.open()
  }

  #closeDialog(target) {
    const dialogElement = target.querySelector('[data-controller*="dialog"]')
    const controller = this.application.getControllerForElementAndIdentifier(
      dialogElement,
      "dialog"
    )
    controller?.closeDialog()
  }
}
